/* eslint-disable no-barrel-files/no-barrel-files */
export { default } from "./src/global-nav";
export type { UniformGlobalNavProps } from "./src/global-nav";
